import React, { useState } from 'react';

import { StepIndicator } from '../components/StepIndicator';
import { AddressStep } from './AddressStep';
import { BrandingStep } from './BrandingStep';
import { BusinessDetailsStep } from './BusinessDetailsStep';
import { ContactInfoStep } from './ContactInfoStep';
import { ReviewStep } from './ReviewStep';

const COMPANY_STEPS = [
  { id: 'business-details', label: 'Business' },
  { id: 'contact-info', label: 'Contact' },
  { id: 'address', label: 'Address' },
  { id: 'branding', label: 'Branding' },
  { id: 'review', label: 'Review' },
];

interface CompanyWizardProps {
  onComplete: () => void;
}

export function CompanyWizard({ onComplete }: CompanyWizardProps) {
  const [currentStep, setCurrentStep] = useState(0);

  const goToStep = (step: number) => {
    if (step >= 0 && step < COMPANY_STEPS.length) {
      setCurrentStep(step);
    }
  };

  const handleNext = () => {
    if (currentStep < COMPANY_STEPS.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <BusinessDetailsStep onNext={handleNext} />;
      case 1:
        return <ContactInfoStep onNext={handleNext} onBack={handleBack} />;
      case 2:
        return <AddressStep onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <BrandingStep onNext={handleNext} onBack={handleBack} />;
      case 4:
        return (
          <ReviewStep
            onNext={onComplete}
            onBack={handleBack}
            onEditStep={goToStep}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto">
      <StepIndicator
        steps={COMPANY_STEPS}
        currentStep={currentStep}
        onStepClick={(step) => step < currentStep && goToStep(step)}
      />
      <div className="bg-[#221F1F] rounded-2xl p-6 border border-[#504A4A]">
        {renderStep()}
      </div>
    </div>
  );
}

